// extracted by mini-css-extract-plugin
export default {"category":"Category_category__nOGEy","title":"Category_title__fGVkE","description":"Category_description__zlLia","price":"Category_price__Ekm4C","header":"Category_header__BsIMf"};